<template>
    <div class="note-btn-group">
		<card type="cinc" class="LentaMessage lightTheme" :class="chatStyle">
			<template v-slot:header>
				<div class="row align-items-center">
					<div class="col">
						<span class="badge badge-pill badge-success mr-1" >{{ message_type }}</span>
						<div class="date note-title">
							<span >{{message.agent_name}}</span>
							<span class="ml-2" v-if="message.InsertTime">{{$GVO.convertDateTimeFromMysql(message.InsertTime)}}</span>
						</div>
					</div>
				</div>
			</template>

			<div class="note-content">
				<h4>{{  message.title }}</h4>
		              <p v-if="message.link"><router-link :to="message.link">{{ message.link_text || message.title }}</router-link></p>
				<p class="note-text">{{ message.descr }}</p>
		    </div>
		</card>
	</div>
</template>

<script>
    export default {
        name: 'LentaMessage',
        default(){
            return{};
        },
        props:{
            message: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            chatStyle: { 
                type: String,
                default: 'StylesDefault',            
            },
            message_type:{
                type: String,
                default: 'Сообщение'
            }
        }
    }
</script>

<style scoped>
.LentaMessage {border: 1px solid rgba(1, 176, 224, 0.4);}
.LentaMessage .date {
	font-size: 12px;
	/* color: #9A9A9A; */
	margin-top: 5px;
}
.LentaMessage >>> .card-body {padding: 0px 15px 15px 15px; }
.badge-grey {background: #9A9A9A; color: #fff;}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4; }
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.note-text {word-break: break-word;white-space: pre-wrap;}

.StylesAuthor {border: 1px solid #00BF9A; background-color: #183d63;}
.white-content .card:not(.card-white) .StylesAuthor {background-color: #ebf3fb!important;} 

.StylesRandom {border: 1px solid #9e77f3;}

.white-content .card:not(.card-white) .StylesDefault {background: #f1f6fc!important; border: 1px solid #c4c4c4;}

.note-content{margin-top: 5px;}
.note-content h4{margin-bottom: 0px;}

@media (max-width: 768px) {	
	.note-content {
		padding: 0px;
	}
}
</style>